module.exports = __webpack_public_path__ + "img/ec.d49ad373.svg";